import React from 'react';

import { ISVGPersonalProps } from 'types/svg';

export const arrowRampLeft: ISVGPersonalProps = {
  viewBox: '0 0 24 24',
  content: (
    <g>
      <path
        d="M6 7L3.08704 9.91296V9.91296C3.03897 9.96103 3.03897 10.039 3.08704 10.087V10.087L6 13"
        stroke="#B3B3B3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 10H7.5C13.299 10 18 14.701 18 20.5V21"
        stroke="#B3B3B3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
};
